import { Organization } from '@cast/types';

import { useDeleteChildOrganizationDialog } from '../../../enterprise/_hooks/useDeleteChildOrganizationDialog';

export const useDeleteOrganizationDialog = () => {
  const { openDialog } = useDeleteChildOrganizationDialog();

  const openModal = (organization: Organization) => {
    openDialog({ organization });
  };

  return { openModal };
};
